import {mailTemplateApi} from '../../api/MailTemplate'

const state = () => ({
    templates: [],
    active: [],
})

// getters
const getters = {
    getAll: state => state.templates,
    getActive: state => state.active,
}

// actions
const actions = {
    loadAll ({ commit }) {
        return mailTemplateApi
            .getAll()
            .then(({ data }) => {
                commit('set', data.data)
            })
            .catch(error => {
                commit('set', [])
                return Promise.reject(error)
            })
    },
}

// mutations
const mutations = {
    set(state, templates) {
        state.templates = templates
        state.active = templates.find(template => template.is_primary_template === true)
            || templates.find(template => template.is_default_template === true)
            || null
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
